import React, { useEffect, useState } from "react";
import { message, Form, Collapse, Modal } from "antd";

import { authSVC } from "../../services";
import { useB2BContext } from "../../context/ContextB2B";
import RequestAddons from "./RequestAddons";
export interface ModuleChild {
  _id: string;
  moduleCode: string;
  label: string;
  category: string;
  allowAccess: boolean;
  child: ModuleChild[];
}

export interface ModuleAccess {
  module_id: string;
  enable: boolean | undefined;
}

export interface ModulesData {
  modules: ModuleChild[];
}

export interface CheckboxListProps {
  items: string[]; // The list of items for checkboxes
  preSelected?: string[]; // Optional list of pre-selected items
}

function AddonsModules({ selectedPackageId }: any) {
  const { getUserByID } = useB2BContext();
  const [userData, setUserData] = useState<any>();
  const [memberModules, setMemberModules] = useState<any>([]);
  const [packageId, setPackageId] = useState<any>("");
  const [preSelectPackages, setPreSelectPackages] = useState<any>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    getUserData();
    AllModule();
  }, []);

  useEffect(() => {
    setPackageId(selectedPackageId);
    console.log(selectedPackageId, "selectedPackageId");
  }, [selectedPackageId]);

  const getUserData = async () => {
    authSVC
      .getByUEmail(getUserByID?.email)
      .then((res: any) => {
        setUserData(res.data.data);
      })
      .catch((err: any) => {
        message.error(err.message);
      });
  };

  const AllModule = async () => {
    authSVC
      .getAllModule()
      .then((res: any) => {
        setMemberModules(res.data.modules);
      })
      .catch((err: any) => {
        message.error(err.message);
      });
  };

  useEffect(() => {
    console.log(packageId, "packageId");
    if (packageId && userData) {
      setTimeout(() => {
        authSVC
          .GetModules(userData?.company_id?._id, packageId)
          .then((res: any) => {
            setPreSelectPackages(res.data.pre_select_packages);
            // alert();
            console.log(
              res.data.pre_select_packages,
              "res.data.pre_select_packages"
            );
          })
          .catch((err: any) => {
            message.error(err.message);
          });
      }, 1000);
    }
  }, [packageId, userData]);

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div className="dataTable">
        <RequestAddons
          preSelectPackages={preSelectPackages}
          modules={memberModules}
        />
      </div>

      <Modal
        footer={false}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        className="subscribe_popup"
      >
        <div className="top_box">
          <img src="/Group14181.svg" alt="" />
          <h3>Unlock More Wellness!</h3>
        </div>
        <div className="plan_choos_wrapper bg_none">
          <p className="discription">
            Upgrade your SOULSARA plan today and access premium features that
            take your well-being to the next level.
          </p>
        </div>
        <button className="continue_btn">Upgrade Plan</button>
      </Modal>
    </>
  );
}

export default AddonsModules;
